<template>
  <q-card class="access-denied-card">
    <div class="access-denied-content">
      <!-- Icon -->
      <div class="access-denied-icon">
        <q-icon name="fas fa-lock" size="42px" color="negative" />
      </div>

      <!-- Message -->
      <div class="access-denied-message">
        Access Denied
      </div>

      <!-- Description -->
      <div class="access-denied-title">
        <vue-typer
          text="You don't have permission to access this page."
          :repeat="0"
          :erase-delay="100000"
          :type-delay="60"
        />
      </div>

      <!-- Hint -->
      <div class="access-denied-hint">
        Please contact your administrator if you believe this is an error.
      </div>
    </div>
  </q-card>
</template>

<script>
import { VueTyper } from "vue-typer";

export default {
  components: {
    "vue-typer": VueTyper
  }
};
</script>

<style lang="scss">
.access-denied-card {
  min-height: 70vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  background: linear-gradient(
    135deg,
    #f8f9fa 0%,
    #f1f3f5 100%
  );

  border-radius: 14px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06);

  overflow: hidden;
}

.access-denied-content {
  width: 100%;
  max-width: 500px;
  padding: 40px 25px;
  text-align: center;
  box-sizing: border-box;
}

/* Icon */
.access-denied-icon {
  width: 90px;
  height: 90px;
  margin: 0 auto 22px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(244, 67, 54, 0.1);
  border: 1px solid rgba(244, 67, 54, 0.15);
  border-radius: 50%;

  box-shadow: 0 8px 25px rgba(244, 67, 54, 0.12);

  animation: pulseIcon 2s infinite;
}

/* Access Denied */
.access-denied-message {
  font-size: 16px;
  font-weight: 600;
  color: #546e7a;
  line-height: 1.5;
  margin-bottom: 8px;
}

/* Vue Typer Text */
.access-denied-title {
  width: 100%;
  font-size: 18px;
  font-weight: 700;
  color: #263238;
  line-height: 1.5;

  /* Important for mobile */
  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
}

.access-denied-hint {
  margin-top: 12px;
  font-size: 13px;
  color: #90a4ae;
  line-height: 1.6;

  white-space: normal;
  overflow-wrap: break-word;
  word-break: break-word;
}

/* Vue Typer */
.vue-typer {
  max-width: 100%;

  .custom.char {
    color: #263238 !important;
  }

  .char.typed {
    color: #263238 !important;
  }
}

/* Tablet */
@media (max-width: 600px) {
  .access-denied-card {
    min-height: 60vh;
    border-radius: 10px;
  }

  .access-denied-content {
    max-width: 100%;
    padding: 30px 20px;
  }

  .access-denied-icon {
    width: 75px;
    height: 75px;
    margin-bottom: 18px;

    .q-icon {
      font-size: 34px !important;
    }
  }

  .access-denied-message {
    font-size: 15px;
  }

  .access-denied-title {
    font-size: 18px;
    line-height: 1.45;
  }

  .access-denied-hint {
    font-size: 12px;
    line-height: 1.5;
  }
}

/* Small Mobile */
@media (max-width: 380px) {
  .access-denied-card {
    min-height: 55vh;
  }

  .access-denied-content {
    padding: 25px 15px;
  }

  .access-denied-icon {
    width: 65px;
    height: 65px;
    margin-bottom: 15px;

    .q-icon {
      font-size: 30px !important;
    }
  }

  .access-denied-message {
    font-size: 14px;
  }

  .access-denied-title {
    font-size: 16px;
    line-height: 1.4;
  }

  .access-denied-hint {
    font-size: 11px;
  }
}

@keyframes pulseIcon {
  0% {
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0.2);
  }

  70% {
    box-shadow: 0 0 0 12px rgba(244, 67, 54, 0);
  }

  100% {
    box-shadow: 0 0 0 0 rgba(244, 67, 54, 0);
  }
}
</style>
